import { dicSeek } from '@/api/pressRole/pressRole';

const dictionary = {
	state:{
		dicStorage:{},
		dicArrStorage:{}
	},

	mutations:{
		DICT_UPDATE:(state,inDats) => {
             if(!state.dicStorage[inDats.code]){
                 state.dicStorage[inDats.code] = inDats.dats;
                 state.dicArrStorage[inDats.code] = inDats.datArrs;
             };             
		}
	},

	actions:{
		dictUpdate({commit,state},inPams){		
			let codeArr = inPams.codeArr;
			return new Promise((resolve,reject)=>{
				let promiseArr = [];
			    let dictStore = state.dicStorage;
				for(let i = 0;i < codeArr.length;i++){
	             	 if(!dictStore[codeArr[i]]){
	             	 	 let inCode = codeArr[i].substr(1,codeArr[i].length-1);
	                     promiseArr.push(new Promise((inResolve,inReject) => {
	                     	  dicSeek({code:inCode}).then(response => {
	                     	  	  //  let unFormate = response.dataDictionarys;
	                     	  	   let unFormate = response.payload;
	                     	  	   let dicDat = {};
	                     	  	   let dicArr = [];
	                     	  	   for(let i = 0;i < unFormate.length;i++){
	                     	  	   	   dicDat[unFormate[i].id] = unFormate[i].name;
	                     	  	   	   let stemp = {
                                           name:unFormate[i].name,
                                           code:unFormate[i].id
	                     	  	   	   };
	                     	  	   	   dicArr.push(stemp);
	                     	  	   };
	                     	  	   let dicMap = {
	                     	  	   	   code:codeArr[i],
	                     	  	   	   dats:dicDat,
	                     	  	   	   datArrs:dicArr
	                     	  	   }
	                     	  	   commit('DICT_UPDATE',dicMap)
	                     	  	   inResolve(response);
	                     	  }).catch(error => {
	                               inReject(error);
	                     	  })
	                     }))
	             	 }
	            };

	            if(promiseArr.length > 0){
	             	 Promise.all(promiseArr).then(result => {
	             	 	 if(inPams.type == 'map'){
	             	 	 	resolve(state.dicStorage);
	             	 	 }else if(inPams.type == 'arr'){
	             	 	 	resolve(state.dicArrStorage);
	             	 	 }
	             	 	 
	             	 }).catch(error => {
	             	 	 reject(error)
	             	 })
	            }else{
	             	     if(inPams.type == 'map'){
	             	 	 	resolve(state.dicStorage);
	             	 	 }else if(inPams.type == 'arr'){
	             	 	 	resolve(state.dicArrStorage);
	             	 	 }
	            }
			})
            
		},
	}
}

export default dictionary;


// WEBPACK FOOTER //
// ./src/store/modules/dictionary.js